import types from './types';

const INITIAL_STATE = {
  list: [],
  metrics: {
    paidCount: 0,
    activeCount: 0,
    totalPaidValue: 0,
    netValue: 0,
  },
  detail: null,
  loading: false,
  creating: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PAYMENT_LINKS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.PAYMENT_LINKS_FETCHED:
      return {
        ...state,
        list: action.payload.list || [],
        metrics: action.payload.metrics || INITIAL_STATE.metrics,
        loading: false,
      };

    case types.PAYMENT_LINK_CREATING:
      return {
        ...state,
        creating: action.payload,
      };

    case types.PAYMENT_LINK_CREATED:
      return {
        ...state,
        list: [action.payload, ...state.list],
        creating: false,
      };

    case types.PAYMENT_LINK_DETAIL_FETCHED:
      return {
        ...state,
        detail: action.payload,
      };

    case types.PAYMENT_LINK_UPDATED:
      return {
        ...state,
        list: state.list.map((link) => (link.id === action.payload.id ? action.payload : link)),
        detail: action.payload,
      };

    case types.PAYMENT_LINK_DELETED:
      return {
        ...state,
        list: state.list.filter((link) => link.id !== action.payload),
      };

    default:
      return state;
  }
};
